import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, inject, OnInit } from '@angular/core';
import { CanAccessPipe } from 'app/core/pipes/can-access.pipe';
import { AuthService } from '../../auth/auth.service';
import { FilterConfig, GlobalFilterPanelComponent } from '../components/global-filter-panel/global-filter-panel.component';
import { DashboardService } from '../dashboard.service';
import { ActiveSurveysComponent } from '../widgets/active-surveys/active-surveys.component';
import { ActivityLogsComponent } from '../widgets/activity-logs/activity-logs.component';
import { DigitalClockComponent } from '../widgets/digital-clock/digital-clock.component';
import { ManagementTodosComponent } from '../widgets/management-todos/management-todos.component';
import { MyActiveSurveysComponent } from '../widgets/my-active-surveys/my-active-surveys.component';
import { MyActivityLogsComponent } from '../widgets/my-activity-logs/my-activity-logs.component';
import { MyEservicesComponent } from '../widgets/my-eservices/my-eservices.component';
import { MyStatisticsCountsComponent } from '../widgets/my-statistics-counts/my-statistics-counts.component';
import { MyTasksComponent } from '../widgets/my-tasks/my-tasks.component';
import { MyTodosComponent } from '../widgets/my-todos/my-todos.component';
import { PaymentMethodsComponent } from '../widgets/payment-methods/payment-methods.component';
import { RecoveryRateComponent } from '../widgets/recovery-rate/recovery-rate.component';

@Component({
  selector: 'app-my-dashboard',
  standalone: true,
  imports: [
    MyStatisticsCountsComponent,
    MyTodosComponent,
    ManagementTodosComponent,
    MyEservicesComponent,
    MyTasksComponent,
    MyActivityLogsComponent,
    ActivityLogsComponent,
    RecoveryRateComponent,
    PaymentMethodsComponent,
    MyActiveSurveysComponent,
    ActiveSurveysComponent,
    DigitalClockComponent,
    GlobalFilterPanelComponent,
    CanAccessPipe,
  ],
  templateUrl: './my-dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyDashboardComponent implements OnInit {
  protected auth = inject(AuthService);
  protected dashboardSvc = inject(DashboardService);
  private cdr = inject(ChangeDetectorRef);

  profile: any;
  greeting = '';
  collectionRecord: any = null;

  fromDate = computed(() => this.dashboardSvc.fromDate());
  toDate = computed(() => this.dashboardSvc.toDate());
  associationId = computed(() => this.dashboardSvc.activeFilters()?.association_id ?? null);

  readonly filterConfig: FilterConfig = {
    community: true,
    period: true,
    dateRange: false,
  };

  ngOnInit() {
    this.profile = this.auth.profile();
    this.greeting = this._buildGreeting();
  }

  onFiltersChanged(f: any): void {
    this.dashboardSvc.activeFilters.set(f);
    this.dashboardSvc.fromDate.set(f.from_date ?? '');
    this.dashboardSvc.toDate.set(f.to_date ?? '');
    this.cdr.markForCheck();
  }

  onCollectionLoaded(record: any): void {
    this.collectionRecord = record;
    this.cdr.markForCheck();
  }

  private _buildGreeting(): string {
    const hour = new Date().getHours();
    const pools = {
      morning: ['Good morning', 'Rise and shine', 'Ready to make it count', 'A fresh start awaits', 'Start strong today'],
      afternoon: ['Good afternoon', 'Keep the momentum going', "You're doing great", 'Stay focused', 'Halfway through - keep it up'],
      evening: ['Good evening', 'Great work today', 'Time to wrap things up', 'Almost there - finish strong', 'Well done today'],
      night: ['Working late tonight', 'Burning the midnight oil', 'The hustle never stops', 'Dedicated as always', 'The night is yours'],
    };
    const pool = hour >= 5 && hour < 12 ? pools.morning : hour >= 12 && hour < 17 ? pools.afternoon : hour >= 17 && hour < 22 ? pools.evening : pools.night;
    return pool[Math.floor(Math.random() * pool.length)];
  }
}
